import React from 'react';

import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { Box, Button, useTheme, Tab, Tabs } from '@mui/material';

import { ReactComponent as ArmiesSVG } from '../../../svgs/design/nav-armies-svg-1.svg';
import { ReactComponent as KingdomSVG } from '../../../svgs/design/nav-kingdom-svg-1.svg';
import { ReactComponent as MilitarySVG } from '../../../svgs/design/nav-military-svg-1.svg';
import { ReactComponent as OpsSVG } from '../../../svgs/design/nav-ops-svg-1.svg';
import { ReactComponent as ResourcesSVG } from '../../../svgs/design/nav-resources-svg-1.svg';
import { ReactComponent as ScienceSVG } from '../../../svgs/design/nav-science-svg-1.svg';
import { ReactComponent as SurveySVG } from '../../../svgs/design/nav-survey-svg-1.svg';
import { ReactComponent as EnemySVG } from '../../../svgs/design/nav-war-grid-svg-0.svg';
import { ReactComponent as WarSVG } from '../../../svgs/design/nav-war-svg-1.svg';

const tabs: string[] = [
  'overview',
  'war',
  'military',
  'survey',
  'science',
  'resources',
  'all',
  'armies',
  'ops',
  'gains',
];

interface Props {
  currentTab: string;
  hasBookNames: boolean;
  hasBuildingNames: boolean;
  handleChangeTab: (e: any, newValue: any) => void;
  isRecentView?: boolean;
}

const IntelGridTabs: React.FC<Props> = ({
  currentTab,
  hasBookNames,
  hasBuildingNames,
  handleChangeTab,
  isRecentView,
}) => {
  const theme = useTheme();
  const getDesktopTabs = () => {
    return (
      <Tabs
        value={currentTab}
        onChange={handleChangeTab}
        scrollButtons
        allowScrollButtonsMobile
        variant='scrollable'
        sx={{
          display: { xs: 'none', sm: 'flex' },
          alignItems: 'center',
        }}
        className='intel-grid-tabs'
      >
        {tabs.map((t) => {
          if (t === 'survey' && !hasBuildingNames) return null;
          if (t === 'science' && !hasBookNames) return null;
          if ((t === 'ops' || t === 'gains') && isRecentView) return null;
          return (
            <Tab
              icon={getIcon(t, t === currentTab)}
              label={t}
              value={t}
              key={t}
              sx={{ fontSize: 13, padding: 1 }}
            />
          );
        })}
      </Tabs>
    );
  };

  const getmobileButtons = () => {
    return (
      <Box
        sx={{
          display: { xs: 'flex-wrap', sm: 'none' },
          justifyContent: 'space-between',
          marginBottom: 1,
          marginLeft: 1,
        }}
        className='mobile-intel-grid-buttons'
      >
        {tabs.map((t) => {
          if (t === 'survey' && !hasBuildingNames) return null;
          if (t === 'science' && !hasBookNames) return null;
          return (
            <Button
              value={t}
              key={t}
              sx={{
                fontSize: 12,
                margin: '2px 2px',
              }}
              variant='outlined'
              onClick={(e) => handleChangeTab(e, t)}
            >
              {t.substring(0, 4)}
            </Button>
          );
        })}
      </Box>
    );
  };

  const getIcon = (value: string, isSelected: boolean) => {
    const props = {
      height: '30px',
      width: '30px',
      fill: `${
        isSelected ? theme.palette.primary.main : theme.palette.text.secondary
      }`,
    };
    switch (value) {
      case 'overview':
        return <KingdomSVG style={props} />;
      case 'war':
        return <WarSVG style={props} />;
      case 'resources':
        return <ResourcesSVG style={props} />;
      case 'military':
        return <MilitarySVG style={props} />;
      case 'survey':
        return <SurveySVG style={props} />;
      case 'science':
        return <ScienceSVG style={props} />;
      case 'ops':
        return <OpsSVG style={props} />;
      case 'armies':
        return <ArmiesSVG style={props} />;
      case 'all':
        return <BookmarkBorderIcon style={props} />;
      case 'gains':
        return <EnemySVG style={props} />;
    }
  };

  return (
    <div className='intel-grid-tabs-container'>
      {getDesktopTabs()}
      {getmobileButtons()}
    </div>
  );
};

export default IntelGridTabs;
